define('modules/form_editor/index',['require','exports','module','common/models/appstate','../editor/models/editorstate','./views/main','./models/form'],function(require, exports, module) {
  "use strict";
  //Form editor service
  var AppState = require("common/models/appstate"),
      EditorState = require("../editor/models/editorstate"),
      FormEditorView = require("./views/main"),
      FormModel = require("./models/form");

  module.exports = {
    editForm: function(formElementModel, callback) {
      var formModel = new FormModel(formElementModel);
      var formEditView = new FormEditorView({ model: formModel,
                                              pages_id: this.editor.options.pageId,
                                              variants_id: this.editor.options.variantId,
                                              platform: this.editor.model.get("platform")});
      AppState.setPropsPopUpOpen(true);

      formEditView.on("form:save", function(results) {
        callback(results);
        AppState.setPropsPopUpOpen(false);

        // Rerender the tree with the new form model
        EditorState.trigger("formChanged", results.model);
        EditorState.setVariantChanged(true, true);
      });
    }
  };
});

